import { createSlice } from '@reduxjs/toolkit';

import type { CartPayments } from '@/modules/cart/domain/CartPayments';
import { getCartPayments } from '@/modules/cart/infrastructure/CartPaymentsRepository/CartPaymentsRepository';

interface InitialState {
  data: CartPayments | undefined;
  isLoading: boolean;
  error?: string;
}

const initialState: InitialState = {
  data: {
    cencoPay: {
      type: 'centPrecision',
      currencyCode: 'CLP',
      centAmount: 0,
      fractionDigits: 0
    },
    cencosudCard: {
      type: 'centPrecision',
      currencyCode: 'CLP',
      centAmount: 0,
      fractionDigits: 0
    },
    otherMethod: {
      type: 'centPrecision',
      currencyCode: 'CLP',
      centAmount: 0,
      fractionDigits: 0
    }
  },
  isLoading: false
};

const CartPaymentsSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(getCartPayments.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCartPayments.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(getCartPayments.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
});

export const cartPaymentsReducer = CartPaymentsSlice.reducer;
